import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { ItemService } from '@services/item.service';
import { WebErrorService } from '@services/webError.service';
import { QuestionSubTypeIdEnum, QuestionTypeIdEnum } from '@configs/questions.config';
import { Editor } from 'ngx-editor';

@Component({
  selector: 'app-test-preview',
  templateUrl: './test-preview.component.html',
  styleUrls: ['./test-preview.component.scss']
})
export class TestPreviewComponent {
  form: FormGroup;
  testItems: any[] = [];
  instructionDescription: any;
  itemIdArray: any[];
  itemId: any;
  displayedColumns: string[] = ['itemBankName', 'itemDescription'];
  selectedTabIndex = 0;

  questions: any[];
  itemsSubscription: any;
  isSelected: any;
  editor: Editor;
  itemBasicDetails = {
    itemBankName: "",
    itemDescription: "",
    collectionId: "",
    itemBankId: "",
    isPublished: false
  };
  panelOpenState = false;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  @ViewChild('previewPopup') previewPopup: TemplateRef<any>

  @ViewChild('table') table: MatTable<any>;
  ItemGroupList: any[];
  constructor(private itemService: ItemService, private dialog: MatDialog, private webErrorService: WebErrorService,) { }
  isItemGroupHide: boolean = true;

  showPopup(data: any) {
    this.editor = new Editor();
    const getIdArray = [];
    this.questions = [];
    this.testItems = [];
    this.ItemGroupList = [];
    if (data) {
      this.dialog.open(this.previewPopup, { width: '100%', height: '600px', panelClass: 'dialog-container' })
      this.testItems = data.name.sort((a, b) => (a.itemOrdertoRender - b.itemOrdertoRender));
      if(data.itemGroupList) {
        this.ItemGroupList = data.itemGroupList.map(e => ({ ...e, items: [] }));
        this.ItemGroupList.forEach((c, index) => {
          this.testItems.forEach((e, index) => {
            if (c.itemCategoryid === e.itemGroupId) {
              c.items.push(e);
            }
          });
        });
      }

      if (this.ItemGroupList.length) {
        const otherItemGroup = this.ItemGroupList.filter(d => d.itemGroupName !== 'Others');
        otherItemGroup.length === 0 ? this.isItemGroupHide = true : this.isItemGroupHide = false;

        this.ItemGroupList = this.ItemGroupList.filter(d=> d.items.length > 0);
        this.isSelected = this.ItemGroupList[0].items[0].itemBankuuId;
      } else {
        this.isItemGroupHide = true;
        this.isSelected = this.testItems[0].itemBankuuId;
      }

      this.itemIdArray = this.testItems;
      this.getInstruction();
      this.itemIdArray.forEach(ft => getIdArray.push(ft.itemId));
    }

    this.getQuestions(this.isSelected);
    // const itemsSubscription = this.itemService.getItemDetails(this.isSelected).subscribe(resData =>
    //   this.questions = resData?.data?.questions, (error: any) => { this.webErrorService.handleAPIErrors(error); }, () => itemsSubscription.unsubscribe());
  }

  closeMatDialog() {
    this.dialog.closeAll();
  }

  getInstruction(itemId?: any) {
    const data = itemId ? this.testItems.find(item => item.itemBankuuId === itemId) : this.testItems[0];
    if (data.instruction) {
      this.instructionDescription = data.instruction;
      this.form = new FormGroup({ editorContent: new FormControl({ value: data.instruction, disabled: true }) });
    }
  }

  getQuestions(itemBankUUID: any) {
    // if (itemBankUUID !== this.isSelected) {
      const itemsSubscription = this.itemService.getItemDetails(itemBankUUID).subscribe(resData => {
        this.getInstruction(itemBankUUID);
        this.questions = resData?.data?.questions;
        this.isSelected = itemBankUUID;
      }, (error: any) => { this.webErrorService.handleAPIErrors(error); }, () => itemsSubscription.unsubscribe());
    // }
  }
}
